export default {
    data: () => ({
        orderModel: {
            firstname: '',
            lastname: '',
            birthdate: "",
            gender: '',
            phone_prefix: '0034',
            phone: '',
            email: '',
            document_type: 'dni',
            dni: '',
            delivery: 1,
            end_lending_at: '',
            lending_point_id: null,
            lending_kit_id: null,
            origin_id: null,
            consumer_type_id: null,
            address: '',
            address_2: '',
            city: '',
            zipcode: '',
            follow_up: false,
            is_sold: 0,
            device: '',
            referer: '',
            observations: '',
            no_sold_reason_id: null,
            no_sold_reason: '',
            pickup_phone: '',
            pickup_address: '',
            pickup_address_2: '',
            pickup_city: '',
            pickup_zipcode: '',
            sell_order_number: '',
            iqos_user_id: '',
            terms_and_conditions: false,
            real_end_lending_at: '',
            order_status_id: 1,
            enable_partner: 0,
            partner_id: null,
            original_order_id: null,
            guided_trial: false,
            fee_payment: false,
            live_abroad: false
        }
    })
}



// WEBPACK FOOTER //
// ./resources/assets/js/markets/CI/pages/orderModel.js